<script>
  import LiveStandingsElement from './LiveStandingsElement.svelte';

  export let value;
  export let lang = undefined;
</script>

<div class='standings'>
  {#each value as item, idx}
    <LiveStandingsElement value={{ position: idx + 1, ...item }} bind:lang/>
  {/each}
</div>

<style>
  .standings {
    display: flex;

    flex-direction: column;

    padding: 20px;
  }
</style>
